import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://backend.kelvinkwesidanquah.com/api/v1/frontend',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Optional: response interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const message = error.response?.data?.message || error.message || 'Network error';
        return Promise.reject({ message, ...error });
    }
);

export default api;